import { Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GeneratorEnv, GENERATOR_ENV_TOKEN } from 'src/app/web-generator/generator-env-token';
import { LoginResultCode } from './LoginResultCode.enum';

/** 所有轉接在 memberProxyService 下的登入服務要實做這個抽象類 */
export abstract class AbstractLoginService {
  /** 已登入的會員資料 */
  get memberInfo() { return this.memberInfo$.value; }

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
  ) {}
  /** 已登入的會員資料 */
  protected memberInfo$ = new BehaviorSubject<any>(null);
  /** 會員(手動)登出後拋出 */
  protected logout$ = new Subject<void>();
  /** 初始化完成事件，完成就帶真值 */
  protected initFinish$ = new BehaviorSubject<boolean>(false);
  /** 登入開始事件，觀察者必須鎖住其他登入模式 */
  protected onLoginStart$ = new Subject<void>();
  /** 登入結束事件，觀察者必須解鎖登入狀態 */
  protected onLoginEnd$ = new Subject<LoginResultCode>();
  /** 登入後操作 api 若失敗的處理方式 */
  abstract errorHandler: (error: any, observable) => Observable<any>;
  /** 已登入的會員資料 */
  getMemberInfo$() { return this.memberInfo$.asObservable(); }
  /** 會員(手動)登出後拋出 */
  getLogout$() { return this.logout$.asObservable(); }
  /** 初始化完成事件，完成就帶真值 */
  getInitFinish$() { return this.initFinish$.asObservable(); }
  /** 登入開始事件，觀察者必須鎖住其他登入模式 */
  getOnLoginStart$() { return this.onLoginStart$.asObservable(); }
  /** 登入結束事件，觀察者必須解鎖登入狀態 */
  getOnLoginEnd$() { return this.onLoginEnd$.asObservable(); }

  /** 初始化登入服務 */
  abstract init(config?: any): void;
  /** 登入流程 */
  abstract login(...args: any[]): Observable<any>;
  /** 登出流程
   * @param fromUser 是否為使用者親自(手動)點擊登出按鈕導致的登出後清資料
   */
  abstract logout(fromUser: boolean): Observable<any>;
}
